package com.milta.feature.aicredit.presentation

import com.milta.core.network.ApiException
import com.milta.core.network.PagedResult

/** R13 — the AI credit history is always read page by page while scrolling, 10 rows at a time. */
const val AI_CREDIT_HISTORY_PAGE_SIZE = 10

/**
 * MIL-98 — paged AI credit history, shared by "Mon usage" (mobile + web, [T] = user rows) and the
 * Admin "Fiche utilisateur" ([T] = rows with tokens and cost). Same rules as the MIL-97
 * optimization history. [error] is "server_error" | "offline" for the last page request.
 */
data class AiCreditHistoryState<T>(
    val items: List<T> = emptyList(),
    val totalCount: Int = 0,
    val loadedPages: Int = 0,
    val isLoadingPage: Boolean = false,
    val error: String? = null,
) {
    val hasMore: Boolean get() = loadedPages == 0 || items.size < totalCount
    val nextPage: Int get() = loadedPages + 1
    val isEmpty: Boolean get() = loadedPages > 0 && items.isEmpty()

    fun withPage(page: PagedResult<T>, idOf: (T) -> String): AiCreditHistoryState<T> {
        val known = items.map(idOf).toSet()
        val merged = items + page.items.filterNot { idOf(it) in known }
        // An empty page before totalCount is reached ends the list instead of asking for it forever.
        val total = if (page.items.isEmpty()) merged.size else page.totalCount
        return copy(items = merged, totalCount = total, loadedPages = page.page, isLoadingPage = false, error = null)
    }

    fun withError(e: Throwable): AiCreditHistoryState<T> =
        copy(isLoadingPage = false, error = if (e is ApiException) "server_error" else "offline")
}
